export const EMAIL_ADDR: string = 'EmailAddr'
